import React from 'react';

class ShipDescription extends React.Component {
  render() {
    const id = this.props.id;
    const info = this.props.data[id];
    const edition = info.edition;
    const block = info.block_number;
    const name = info.name == "" ? "Unnamed" : info.name;
    const src = "./assets/"+id+".png";
    const ipfs = info.ipfs;
    return (
      <div className="ShipDescription">
        <div className="ShipInfo">{"Artifact No. "+id}</div>
        <div className="ShipInfo">-</div>
        <div className="ShipInfo">{"Edition: "+edition}</div>
        <div className="ShipInfo">{"Block: "+block}</div>
        <div className="ShipInfo">{"Name: "+name}</div>
        <div className="ShipInfo">{"IPFS: "+ipfs}</div>
        <img className="ShipImage" src={src} width="125px" height="125px" alt=""/>
      </div>
    );
  }
}

export default ShipDescription;